import { fa_danthuoc_chitiet } from '../../models/response/y-te/fa_danthuoc';
import { apiClient } from '../apiClient';
import { BaseCRUDApi } from '../baseCRUDApi';

export const API_DAN_THUOC_CHITIET_PATH = 'danthuoc-chitiet';

class DanThuocChiTietApi extends BaseCRUDApi<fa_danthuoc_chitiet> {
	// eslint-disable-next-line @typescript-eslint/no-useless-constructor
	constructor(path: string) {
		super(path);
	}
	/** Backend đặt route `select-all` (adm client gọi thiếu, bị 404) */
	SelectAllView() {
		return apiClient.get(`${API_DAN_THUOC_CHITIET_PATH}/select-all`);
	}
	SelectByDanThuoc(fa_danthuoc_id: number) {
		return apiClient.get(`${API_DAN_THUOC_CHITIET_PATH}/dan-thuoc/${fa_danthuoc_id}`);
	}
}
export const danThuocChiTietApi = new DanThuocChiTietApi(API_DAN_THUOC_CHITIET_PATH);
